import CloseIcon from "src/images/Icons/newIcons/close.svg";

import { htmlFormatter } from "../../../formatters/htmlFormatter";
import {
	useCloseCooperations,
	useCooperations,
} from "../../../hooks/useCooperations";
import { IconButton } from "../../Default/LekUI/Button";

function addLinkToText(cooperation) {
	const box = document.createElement("div");
	box.innerHTML = cooperation.text;
	const link = document.createElement("a");
	link.setAttribute("href", cooperation.link);
	link.setAttribute("target", "_blank");
	link.setAttribute("rel", "noreferrer noopener");
	link.setAttribute("class", "ml-8");
	link.innerText = cooperation.button_text;
	box.firstChild.appendChild(link);

	return box.innerHTML;
}

function Cooperations() {
	const { data, isLoading } = useCooperations();
	const { mutateAsync } = useCloseCooperations();

	if (isLoading || !data || data.length === 0) {
		return null;
	}

	const [cooperation] = data;

	return (
		<div className="box cooperation">
			{cooperation.image_url && (
				<img
					className="cooperation--image"
					src={cooperation.image_url}
					alt={cooperation.name}
				/>
			)}
			<div className="clear-fix">
				{htmlFormatter(addLinkToText(cooperation))}
			</div>
			<IconButton
				className="cooperation--close"
				onClick={() => mutateAsync({ id: cooperation.id })}
			>
				<CloseIcon className="icon-small" />
			</IconButton>
		</div>
	);
}

export default Cooperations;
